import DefaultResetForm from '@/components/DefaultResetForm';
import { CustomTextField } from '@/components/Formik/CustomTextField';
import { useUser } from '@/contexts/AuthContext';
import { api } from '@/services/apiClient';
import { resetAlternativeEmail } from '@/validators/resetUsersInfo';
import { FormikValues } from 'formik';
import { IModalSuccessData } from '.';

interface ResetAlternativeEmail {
  onSuccess: (value: IModalSuccessData) => void;
  handleClose: () => void;
}

const ResetAlternativeEmail = ({
  onSuccess,
  handleClose,
}: ResetAlternativeEmail) => {
  const { user, updateUserData } = useUser();

  const handleSubmitResetAlternativeEmailForm = async (
    values: FormikValues
  ) => {
    const userUpdate = {
      cpf: user?.cpf,
      name: user?.name,
      email: user?.email,
      alternative_email: values.alternative_email,
      username: user?.username,
      display_name: user?.display_name,
    };

    await api.put('/auth/users/me/', userUpdate);

    onSuccess({
      isOpen: true,
      text: 'Seu e-mail alternativo foi alterado com sucesso!',
    });
    updateUserData(userUpdate);
  };

  return (
    <DefaultResetForm
      title="Informe um email alternativo para sua conta"
      onSubmit={handleSubmitResetAlternativeEmailForm}
      handleCancel={handleClose}
      handleClose={handleClose}
      initialValues={{
        alternative_email: user?.alternative_email,
      }}
      validationSchema={resetAlternativeEmail}
    >
      <CustomTextField
        label="E-mail alternativo *"
        name="alternative_email"
        variant="standard"
      />
    </DefaultResetForm>
  );
};

export default ResetAlternativeEmail;
